"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsImportSelectHeader = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const button_1 = require("client/components/material/button");
const alert_1 = require("client/components/ui/alert");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/patients/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./patients-import-select-header.less");
const core_1 = require("@material-ui/core");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const paper_1 = require("client/components/material/paper");
/**
 * Renders a table from a parsed csv to allow a user to select a header row.
 * The parsed csv comes back as an array of arrays of rows from the csv spreadsheet.
 * The table is laid out in a <table> element -- which wraps a <tbody> tag -- by mapping through the array of arrays
 * with each row representing a parsed row (patient in this case) and returning
 * it wrapped in a <tr> tag.
 *
 * Purpose:
 *  1. save user's selected row;
 *  2. parse the array of arrays of rows from the spreadsheet to an array of objects representing individule patients with the proper imported header.;
 *
 * @returns void
 *
 */
let PatientsImportSelectHeader = class PatientsImportSelectHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.parsedRows = [];
        this.parsedRowsTruncated = [];
        this.rowSelected = false;
        this.selectedRowIndex = null;
        this.noHeaderRowSelectOnConfirm = false;
        this.getTheRawDataForFilter = [];
        /**
         * Parse the array of arrays of rows to an array of objects, each representing a patient with the proper headers from the import;
         *
         * @returns the array of objects of patients;
         */
        this.getImportedRowsObject = () => {
            const headers = this.parsedRowsTruncated.slice(0, 1)[0]
                ? this.parsedRowsTruncated
                    .slice(0, 1)[0]
                    .filter((item) => item != '') //B-085.6
                    .map((header) => header.trim())
                : this.parsedRowsTruncated.slice(0, 1)[0];
            const rows = this.parsedRowsTruncated.slice(1);
            const importedData = rows.map(row => {
                const patient = {};
                row.forEach((value, index) => {
                    patient[headers[index]] = value;
                });
                return patient;
            });
            return importedData;
        };
        /**
     * lav changes just created this function to filter the blank value headers.B-085
     * B-085
     */
        this.getRawDataToFilterTheBlankData = async () => {
            const headers = this.parsedRows.slice(this.selectedRowIndex).slice(0, 1)[0]
                ? this.parsedRows.slice(this.selectedRowIndex)
                    .slice(0, 1)[0]
                    .map((header) => header.trim())
                : this.parsedRows.slice(this.selectedRowIndex).slice(0, 1)[0];
            const rows = this.parsedRows.slice(this.selectedRowIndex).slice(1);
            console.log("rowss", rows);
            const importedData = rows.map(row => {
                const patient = {};
                row.forEach((value, index) => {
                    patient[headers[index]] = value;
                });
                return patient;
            });
            this.getTheRawDataForFilter = importedData;
        };
        /**
         * Check whether a header row has been selected:
         * If a row has been selected, save the selected row to patientStore.importColumnsHeader;
         *
         * @returns void
         */
        // public handleOnConfirmation = () => {
        //   if (!this.rowSelected) {
        //     this.noHeaderRowSelectOnConfirm = true;
        //   } else {
        //     patientsStore.importColumnsHeader = this.parsedRows[
        //       this.selectedRowIndex || 0
        //     ];
        //   }
        //   this.parsedRowsTruncated = this.parsedRows.slice(this.selectedRowIndex);
        //   patientsStore.importedPatients = this.getImportedRowsObject();
        //   patientsStore.selectedRowIndex = this.selectedRowIndex;
        // };
        // B-085 luv chnages 
        this.handleOnConfirmation = async () => {
            let finalArrData = [];
            if (!this.rowSelected) {
                this.noHeaderRowSelectOnConfirm = true;
            }
            else {
                let blankKey = [];
                let data = this.parsedRows[this.selectedRowIndex || 0];
                for (const key in this.getTheRawDataForFilter[0]) {
                    if (this.getTheRawDataForFilter.every(obj => obj[key] === '')) {
                        blankKey.push(key);
                    }
                }
                ;
                data.map((item) => {
                    if (!blankKey.includes(item)) {
                        finalArrData.push(item);
                    }
                });
                store_1.patientsStore.importColumnsHeader = finalArrData;
            }
            this.parsedRowsTruncated = this.parsedRows.slice(this.selectedRowIndex);
            store_1.patientsStore.importedPatients = this.getImportedRowsObject();
            store_1.patientsStore.selectedRowIndex = this.selectedRowIndex;
        };
        this.handleOnCancel = () => {
            // console.log('handleOnCancel triggered');
        };
        /**
         * @param e event for on click
         * @param i index of the row clicked on
         *
         * Determine state of the rows and dictates the accent style;
         * Determines whether rowSelected predicate;
         */
        this.handleOnClickRow = async (e, i) => {
            await this.getRawDataToFilterTheBlankData(); //luv changes B-085
            const rowClicked = document.getElementById(`select-header-table__row--${i}`);
            const allRows = document.getElementsByClassName("select-header-table__row");
            [...allRows].forEach(row => row.classList.remove("active-row"));
            rowClicked.classList.add("active-row");
            this.selectedRowIndex = i;
            this.rowSelected = true;
        };
        this.renderTableRow = (row, i) => {
            console.log("row is -----------", row);
            return (React.createElement(core_1.TableRow, { className: `select-header-table__row`, id: `select-header-table__row--${i}`, onClick: e => this.handleOnClickRow(e, i), key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
        };
    }
    // B-085
    /**
     * Get the import parsed rows from patientStore and store it in locally as this.parsedRows;
     *
     * Create an array of objects representing each patients by calling the getImportedRowsObject() method
     * and save it to patientStore.importedPatients;
     *
     * @returns void
     */
    componentWillMount() {
        this.parsedRows = store_1.patientsStore.parsedRows[0]
            ? store_1.patientsStore.parsedRows[0].length
                ? store_1.patientsStore.parsedRows[0]
                : []
            : [];
    }
    render() {
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--select" },
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Header Selection", subLabel: "" })),
                React.createElement(paper_1.MaterialPaper, { className: "orders-submit-select__header-select" },
                    this.noHeaderRowSelectOnConfirm && (React.createElement("div", { className: "ui-alert--error" },
                        React.createElement(alert_1.UiAlert, { message: "Missing header row selection.", dismissable: true, onRequestDismiss: () => (this.noHeaderRowSelectOnConfirm = false) }))),
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please select a header row"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/patients" }, "Cancel"),
                            React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleOnConfirmation, to: this.rowSelected ? "/patients/import/map" : null, disabled: !this.rowSelected }, "confirm"))),
                    React.createElement("div", { className: "select-header-table", style: { overflow: "auto" } },
                        React.createElement(core_1.Table, null,
                            React.createElement(core_1.TableBody, null, this.parsedRows // change to this.localTable for testing; this.parsedRows when done
                                .slice(0, 20)
                                .map((row, i) => this.renderTableRow(row, i))))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Make changes", message: `Please confirm you have mapped the correct headers.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: () => alert("confirmed"), title: "Confirm header mappings" }))));
    }
};
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "parsedRowsTruncated", void 0);
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "rowSelected", void 0);
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "selectedRowIndex", void 0);
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "noHeaderRowSelectOnConfirm", void 0);
__decorate([
    mobx_1.observable
], PatientsImportSelectHeader.prototype, "getTheRawDataForFilter", void 0);
PatientsImportSelectHeader = __decorate([
    mobx_react_1.observer
], PatientsImportSelectHeader);
exports.PatientsImportSelectHeader = PatientsImportSelectHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-import-select-header/patients-import-select-header.tsx
// module id = 3821
// module chunks = 0